import React, { useState } from 'react'

const FILTER_TOGGLE_EVENT = 'layout:filters-toggle'

export default function CollapsibleFilters({
  title = 'Filters',
  initiallyOpen = false,
  className = 'bg-white rounded-t-lg border border-gray-200 shadow mb-0',
  contentClassName = 'p-4 border-t border-gray-200',
  children
}) {
  const [isOpen, setIsOpen] = useState(initiallyOpen)

  const handleToggle = () => {
    setIsOpen((prev) => {
      const next = !prev
      window.requestAnimationFrame(() => {
        window.dispatchEvent(new Event(FILTER_TOGGLE_EVENT))
      })
      return next
    })
  }

  return (
    <div className={className}>
      <button
        type="button"
        onClick={handleToggle}
        className="w-full flex items-center justify-between px-4 py-3 text-left bg-gray-100 rounded-t-lg"
      >
        <span className="text-sm font-semibold text-gray-700">{title}</span>
        <span className="text-xs font-semibold text-blue-600">{isOpen ? 'Hide' : 'Show'}</span>
      </button>

      {isOpen && (
        <div className={contentClassName}>
          {children}
        </div>
      )}
    </div>
  )
}
